import { Text } from "/react4xp/parts/text/text";

export default (props) => <Text {...props} />